import * as React from "react";

import styled from "styled-components";
import avatar from "../assets/images/helpcentericons/profileicon.png";
import background from "../assets/images/storybg.svg";
import background1 from "../assets/images/storybg.png";

const Story = styled.div`
        // background-image: url(${background1});
        background-repeat: no-repeat;
        background-position: auto auto ;
        background-size: cover;
        width: 100%;
        height:auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-items: flex-start;
        font-size: 1.25em;

        .student-thumbnail {
            width:35%;
            height: auto;
            // border-left: solid #ff0033 2px;
            // border-top: solid 2px #ff0033;
        }

        .story-details {
            width: 50%;
            display: flex;
            flex-direction: column;
            color: white;
            margin-top: 5%;
            // padding: .75em 2em;
        }

        .story-title{
                text-transform: uppercase;
                font-style: italic;
                font-family: "Roboto Condensed", sans-serif;
                font-weight: bold;
                font-size: 24px;
            }

            .story-body {
                font-size: 16px;
                // width: 70%;
                line-height: 1.43;
                font-family: "Roboto", sans-serif;
            }

            .watch-button {
                background-color: #ff0033;
                color: #000;
                text-transform: uppercase;
                font-style: italic;
                font-family: "Roboto Condensed", sans-serif;
                border: none;
                font-size: 14px;
                font-weight: bold;
                height: 30px;
                width: 150px;
                margin-bottom: 4em;
                border-radius: 2px;
            }

            .watch-button:hover {
                background-color: #99001f;
            }
        }
        @media all and (min-width: 692px) and (max-width: 768px) {
            .student-thumbnail {
                width: 25%;
            }
        }
        @media all and (min-width: 769px) and (max-width: 1200px) {
            .student-thumbnail {
                width: 20%;
            }
        }`;

const StudentStory = (props) => {
  return (
    <Story>
      <div className="student-thumbnail">
        <img src={avatar} alt="student-thumbnail" />
      </div>
      <div className="story-details">
        <h3 className="story-title">Sanjay's Story</h3>
        <p className="story-body">
          Sanjay has been on Performance Learning for two years now <br />
          Listen to what he has to say!
        </p>
        <button
          className="watch-button"
          value="X69QMZOKbo0"
          onClick={props.openModal}
        >
          Watch Story
        </button>
      </div>
    </Story>
  );
};

export default StudentStory;



// WEBPACK FOOTER //
// ./src/common/studentStory.Component.tsx